var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 193,
    viewBox: "0 0 317 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.75 37.725C116.25 -12.575 199.85 -12.575 251.35 37.725L257.55 43.825C260.15 46.325 260.15 50.425 257.55 52.925L236.35 73.625C235.05 74.925 232.95 74.925 231.65 73.625L223.15 65.325C187.15 30.225 128.95 30.225 92.95 65.325L83.85 74.225C82.55 75.525 80.45 75.525 79.15 74.225L57.95 53.525C55.35 51.025 55.35 46.925 57.95 44.425L64.75 37.725ZM295.25 80.525L314.15 98.925C316.75 101.425 316.75 105.525 314.15 108.025L229.05 191.125C226.45 193.625 222.25 193.625 219.75 191.125L159.35 132.125C158.75 131.525 157.65 131.525 157.05 132.125L96.65 191.125C94.05 193.625 89.85 193.625 87.35 191.125L1.95 108.025C-0.65 105.525 -0.65 101.425 1.95 98.925L20.85 80.525C23.45 78.025 27.65 78.025 30.15 80.525L90.55 139.525C91.15 140.125 92.25 140.125 92.85 139.525L153.25 80.525C155.85 78.025 160.05 78.025 162.55 80.525L222.95 139.525C223.55 140.125 224.65 140.125 225.25 139.525L285.65 80.525C288.45 78.025 292.65 78.025 295.25 80.525Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/walletConnect.3658dd8daa01f576ea0e08f09ae58b95.svg";
export { ForwardRef as ReactComponent };